import clsx from 'clsx';

import styles from './index.module.scss';

interface NotificationDotProps {
  title?: string;
  className?: string;
}

export default function NotificationDot({ title = 'New', className }: NotificationDotProps): JSX.Element {
  return (
    <span className={clsx(styles.dot, className)} role="status" aria-label={title} title={title} />
  );
}
